



























import Vue from "vue"
import {RunnerInfo} from "../lib/runner-utils"
import request from "../lib/request"
import RunnerSummary from './RunnerSummary.vue'

export default Vue.extend({
  props: ['excludes'],

  data() {
    return {
      runners: <RunnerInfo[]>[]
    }
  },

  components: {
    RunnerSummary
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      let excludes: string[] = this.excludes || []
      request.getRunners()
        .then(infos => {
          this.runners = infos.filter(info => {
            return excludes.indexOf(info.name) === -1
          })
        })
    },

    close() {
      this.$emit('close')
    },

    choose(runnerInfo: RunnerInfo) {
      this.$emit('choose', runnerInfo)
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChooseRunner.vue